import React from "react";
import AuthPartnerLayout from "../../../components/AuthPartnerLayout";
import {Spinner} from "reactstrap";
import {initialValues, validationSchema} from "../../ResetPassword/form";
import { Formik } from "formik";
import {BUTTON_COLORS, BUTTON_STYLES} from "../../../../../base/components/Button/appearance";
import Button from "../../../../../base/components/Button";
import FormikInput from "../../../../../base/components/FormikInput";
import {MAX_PASSWORD_LENGTH} from "../../../../../validation/lengthConstants";
import {PasswordWithStrength} from "../../../../../base/components/PasswordWithStrength";
import joinClassNames from "../../../../../base/helpers/joinClassNames";

const  ResetPasswordPartner = ({isLoading, onSubmit, isLoadingReset}) => {
    return(
        <AuthPartnerLayout>
            <section
                className="partner-sign-up-section w-full d-flex justify-content-center"
            >
                {isLoading &&
                <section className="w-100 text-center">
                    <Spinner color="info"/>
                </section>
                }
                {!isLoading && <h1 className="partner-sign-up-title">
                    Welcome! <br/> Let’s create password for account security
                </h1>}
                {!isLoading &&  <div className="partner-sign-up-form">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        validateOnMount
                        onSubmit={(values) => {
                            onSubmit(values);
                        }}
                    >
                        {({errors, handleSubmit}) => (
                            <form className="form-horizontal" onSubmit={handleSubmit}>
                                <PasswordWithStrength
                                    id="password"
                                    label="Create password"
                                    name="password"
                                    type="password"
                                    withEyeOption
                                    containerClassName={joinClassNames("position-relative mb-3")}
                                    placeholder="Create new password"
                                    maxLength={MAX_PASSWORD_LENGTH}
                                />

                                <FormikInput
                                    id="repeatPassword"
                                    label="Confirm password"
                                    name="repeatPassword"
                                    type="password"
                                    withEyeOption
                                    containerClassName={joinClassNames("position-relative")}
                                    placeholder="Confirm new password"
                                    maxLength={MAX_PASSWORD_LENGTH}
                                />
                                <Button
                                    color={BUTTON_COLORS.primary}
                                    type="submit"
                                    block={BUTTON_STYLES.block}
                                    loading={isLoadingReset}
                                    className="mt-4-5"
                                    disabled={isLoadingReset || !!Object.keys(errors).length}
                                >
                                    Confirm password
                                </Button>
                            </form>
                        )}
                    </Formik>
                </div>}
            </section>
        </AuthPartnerLayout>
    )
}

export default ResetPasswordPartner